import * as React from 'react';
import {
    UpgradeHelper, IJourneyItem,AdminToolPanelHelper, IAdminToolPanel
} from '../../helpers';
import { Search } from '../common/search';
declare var jQuery;
interface IProps {
    panelTitle: string;
    enableToggle: boolean;
    isEnabled: boolean;
    adminToolState: any;
    panelName: any;
}

export class PanelHeader extends React.Component<IProps, any> {
    onClickShowOrHideButton = (event: any) => {
        var $element = jQuery(event.target);
        var $container = jQuery($element).parent().parent();

        if (jQuery(".panel-content", $container).is(':visible')) {
           AdminToolPanelHelper.SetUpPanelState(this.props.adminToolState, this.props.panelName, false, false);
        }
        else {
           AdminToolPanelHelper.SetUpPanelState(this.props.adminToolState, this.props.panelName, true, false);
        }
    }

    render() {
        let panel:IAdminToolPanel =AdminToolPanelHelper.GetPanel(this.props.adminToolState, this.props.panelName);
        let isDisplayed:boolean = AdminToolPanelHelper.IsPanelDisplayed(panel);
        let className:string = "icon mintoolpanel" + ((!isDisplayed) ?  " disabled" : "");
        return (
            <h2 className={"admintool-panelheader"}>{this.props.panelTitle} {this.props.enableToggle && <i className={className} onClick={(e) => this.onClickShowOrHideButton(e)}></i>}</h2>
        );
    }
}  



// WEBPACK FOOTER //
// ./source/ts/components/admintool/panelheader.tsx